<template>
    <div>
        <b-navbar toggleable type="dark" variant="t-dark-" class="p-4">
            <b-navbar-brand>
                <img class="side-logo" src="img/logo/timpel.png">
            </b-navbar-brand>

            <b-navbar-toggle target="navbar-toggle-collapse">
                <template #default="{ expanded }">
                    <b-icon v-if="expanded" icon="list"></b-icon>
                    <b-icon v-else icon="list"></b-icon>
                </template>
            </b-navbar-toggle>

            <b-collapse id="navbar-toggle-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <UserCard/>
                    <MenuItems/>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import MenuItems from '@/components/base/MenuItems.vue'
import UserCard from '@/components/base/UserCard.vue'

export default {
    components:{
        UserCard,
        MenuItems
    }
}
</script>

<style>

</style>